// Get environment variables with fallbacks for both Vite and Create-React-App
const getEnv = (key: string, fallback: string): string => {
  // Try Vite style env vars first
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
    return import.meta.env[key];
  }
  // Fall back to default
  return fallback;
};

// Okta configuration
export const oktaConfig = {
  clientId: getEnv('VITE_OKTA_CLIENT_ID', '{{clientId}}'),
  issuer: getEnv('VITE_OKTA_ISSUER', '{{issuer}}'),
  // Use explicit redirect URI from env if available, otherwise construct from origin
  redirectUri: getEnv('VITE_OKTA_REDIRECT_URI', window.location.origin + '/login/callback'),
  postLogoutRedirectUri: window.location.origin + '/home',
  scopes: ['openid', 'profile', 'email'],
  pkce: true
};
